import React, { Component } from "react";
import { Button } from "react-bootstrap";

export class CopyToClipboard extends Component {
  state = { tooltipVisibility: false };

  onCopy = e => {
    try {
      const { tooltipVisibility } = this.state;
      if (!tooltipVisibility) {
        if (navigator.clipboard) {
          // write the data in clip board
          navigator.clipboard.writeText(e.target.innerHTML);
          // set the tooltip visibility
          this.setState({ tooltipVisibility: true }, () => {
            // hide the tooltip after 1 sec
            this.scheduleToolTipVisibility();
          });
        } else {
          console.error("Browser doesnot support clipboard api");
        }
      } else {
        this.setState({ tooltipVisibility: false });
      }
    } catch (error) {
      console.error(error);
    }
  };

  scheduleToolTipVisibility = () => {
    setTimeout(() => {
      this.setState({ tooltipVisibility: false });
    }, 1000);
  };

  render() {
    const {
      props: { children },
      state: { tooltipVisibility },
      onCopy
    } = this;

    return (
      <div className="clipboard-container" onClick={onCopy}>
        {children}
        {tooltipVisibility ? (
          <Button variant={"info"} className="copied-buton animated bounceIn">
            Copied!
          </Button>
        ) : null}
      </div>
    );
  }
}
